<table class="table table-striped table-hover">
	<thead>
		<tr>
			<th *ngFor="let header of headers">
				<span>{{ header.label }}</span>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data; let i = index">
			<td>{{ i + 1 }}</td>
			<td>{{ item.date }}</td>
			<td>{{ item.userName }}</td>
		</tr>
	</tbody>
</table>
